export const IconWideChoiceCandidates20: {
  name: 'icon_wide_choice_candidates_20-501f8cad2d66'
} = {
  name: 'icon_wide_choice_candidates_20-501f8cad2d66'
}
